import { useState } from "react";
import { Modes } from "./io-abstract";
import IODate from "./io-date";
import IOList from "./io-list";
import IONumber from "./io-number";
import IOString from "./io-string";
import { getPref } from "./search-panel";

type periodChoices = "day" | "month" | "year";

export function getPeriodRange(
  period: periodChoices,
  day?: string,
  month?: string,
  year?: string
) {
  // Day period by default
  let date_start = day;
  let date_end = day;

  switch (period) {
    case "day":
      if (!day) {
        throw new Error("Day is required for day period");
      }
      date_start = day;
      date_end = day;
      break;
    case "month": {
      if (!month) {
        throw new Error("Month is required for month period");
      }
      const [sYear, sMonth] = month.split("-");
      // Day 0 of the next month (month should be counted from 0)
      const lastDay = new Date(Number(sYear), Number(sMonth), 0).getDate();
      date_start = `${month}-01`;
      date_end = `${month}-${String(lastDay).padStart(2, "0")}`;
      break;
    }
    case "year": {
      if (!year) {
        throw new Error("Year is required for year period");
      }
      date_start = `${year}-01-01`;
      date_end = `${year}-12-31`;
      break;
    }
  }
  return { date_start, date_end };
}

export function IPeriod(): React.ReactNode {
  const [period, setPeriod] = useState<periodChoices>(
    getPref("period", "month") as periodChoices
  );
  const [day, setDay] = useState<string>(
    getPref("day", new Date().toISOString().substring(0, 10))
  );
  const [month, setMonth] = useState<string>(
    getPref("month", new Date().toISOString().substring(0, 7))
  );
  const [year, setYear] = useState<string>(
    getPref("year", new Date().getFullYear().toString())
  );

  const timeRange = getPeriodRange(period, day, month, year);

  return (
    <>
      <input type="hidden" name="date_start" value={timeRange.date_start} />
      <input type="hidden" name="date_end" value={timeRange.date_end} />
      <IOList
        name="period"
        mode={Modes.input}
        list={["day", "month", "year"]}
        value={period}
        required
        onChange={(period) => setPeriod(period as periodChoices)}
      />
      {period === "day" && (
        <IODate
          name="day"
          mode={Modes.input}
          value={day}
          onChange={(day) => setDay(day)}
        />
      )}
      {period === "month" && (
        <IOString
          name="month"
          mode={Modes.input}
          value={month}
          onChange={(month) => setMonth(month)}
          htmlProps={{ pattern: "[0-9]{4}-[0-9]{1,2}" }}
        />
      )}
      {period === "year" && (
        <IONumber
          name="year"
          mode={Modes.input}
          value={Number(year)}
          onChange={(year) => setYear(year.toString())}
          htmlProps={{ min: 1990, max: 2100 }}
        />
      )}
    </>
  );
}
